const templatePost = (WpTag = '') => `
  databaseId
  title
  content
  date
  excerpt
  featuredImage {
    node {
      altText
      sourceUrl
      srcSet
    }
  }
  categories {
    nodes {
      slug
      name
    }
  }
  id
  slug
  tags {
    nodes {
      slug
      name
    }
  }
  uri
  template {
    ...on ${WpTag}TemplateInner {
      templateName
      templateInnerPost {
        templateInnerHero {
          templateInnerHeroBackButton
          templateInnerHeroMainButton {
            templateInnerHeroMainButtonText
          }
          templateInnerHeroTemplate {
            ...on ${WpTag}GoScreverTemplate {
              id
              title
              goScreverTemplates {
                goScreverTemplatesId
              }
            }
          }
        }
        templatePageInActionForm
        templatePageCustomTitleForArticle
      }
    }
    ...on ${WpTag}Template_LeadGenerator {
      templateName
      templateLeadGenerator {
        templateLeadGeneratorHero {
          templateLeadGeneratorHeroTitle
          templateLeadGeneratorHeroDescription
          templateLeadGeneratorHeroBackButton
          templateLeadGeneratorHeroBanner {
            altText
            srcSet
            sourceUrl
          }
        }
        templatePageInActionForm
        templatePageCustomTitleForArticle
        templateLeadGeneratorAttachFileToDownload {
          mediaItemUrl
        }
      }
    }
  }
  seo {
    canonical
    cornerstone
    focuskw
    metaDesc
    metaKeywords
    metaRobotsNofollow
    metaRobotsNoindex
    opengraphAuthor
    opengraphDescription
    opengraphModifiedTime
    opengraphPublishedTime
    opengraphPublisher
    opengraphSiteName
    opengraphTitle
    opengraphType
    opengraphUrl
    readingTime
    title
    twitterDescription
    twitterTitle
    opengraphImage {
      sourceUrl
    }
    twitterImage {
      sourceUrl
    }
    breadcrumbs {
      text
      url
    }
    schema {
      articleType
      pageType
    }
  }
  language {
    code
    name
    locale
    slug
  }
`;

module.exports.templatePost = templatePost;
